// enums.ts
export enum ApplicationEnum {
	WORKSUITE = "worksuite",
	ADMIN = "admin",
	SETTINGS = "settings",
	FULFILL = "fulfill",
	PRODUCE = "produce",
	RESTOCK = "restock",
	FORECAST = "forecast",
	AVAILABILITY = "availability",
	MATERIAL = "material",
	VERIFY = "verify",
	ENGAGE = "engage",
	COUNT = "count",
	EVENTS = "events",
	INTELLIGENCE = "intelligence",
	BENCHMARK = "benchmark",
	PORTAL = "portal",
	REPORTS = "reports"
}
